export default "__VITE_ASSET__DNTZqXcR__"